export type ExtractCollapserItem = {
  /** Заголовок */
  title: string;
  /** Полное HTML-тело iframe */
  content: string;
  /** Id коллапсера */
  id: string;
  /** Полное HTML-тело шаблона adfox */
  outerHtml: string;
};

export interface IExtractCollapserParams {
  /** HTML-контент */
  html: string;
  /** Коллекция параметров коллапсера */
  items: ExtractCollapserItem[];
}

/**
 * 1. Извлекает из HTML шаблон collapser с параметрами
 * 2. Вырезает данные коллапсера из HTML и заменяет пустым div'ом c id (опционально)
 * @param html - исходный HTML
 * @param replaceHtml - вырезать ли шаблон из HTML
 * @returns - Объект с исходным/измененным html и коллекцию параметров
 */
export const extractCollapserParams = (html: string, replaceHtml: boolean = false): IExtractCollapserParams => {
  const pattern =
    /<div[^>]*?(?:class="collapse")>[^<]*?<div[^>]*?(?:class="collapse__title")>(.*?)<\/div>[^<]*?<div[^>]*?(?:class="collapse__content")>(.*?)<\/div>[^<]*?<\/div>/gis;
  const items: ExtractCollapserItem[] = [];
  let match;

  if (!html) {
    return {
      html: '',
      items: [] as ExtractCollapserItem[],
    };
  }

  while ((match = pattern.exec(html))) {
    items.push({
      outerHtml: match[0],
      title: match[1],
      content: match[2],
      id: `collapser-${items.length + 1}`,
    });
  }

  return {
    html: replaceHtml
      ? items.reduce((acc, item) => {
          return acc.replace(item.outerHtml, `<div id="${item.id}"></div>`);
        }, html)
      : html,
    items,
  };
};
